export const URL = (location.hostname == 'isoterminal.com') ? 'https://app.lendwizely.com' 
    : (location.hostname == 'localhost') ? 'http://app.lendwizely.local'
    : 'http://44.227.99.35:8080' // mca dev url
export const config = {
    headers: {'Access-Control-Allow-Origin': '*'}
};

